module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/1/5-cb23260a8aed066198c7de99549d7f75.jpg";